// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"Group_checkboxGroup__CAu4a"};